import { useEffect } from 'react';
import { Box } from '@mui/material';
import { useLocation } from 'react-router';
import { useDispatch } from 'react-redux';

import { Strings } from '@app/constants';
import { Header } from '@app/sections/header';
import { useDialog, useRequestState } from '@app/hooks';
import { ClientProfile } from './client-profile';
import { AddClient } from '../view/add-client';
import { ClientDetailsList } from './client-details-list';
import { selectClientDetailsByIdState, selectClientDetailsState } from '../selector';
import { useTable } from '@app/components/table';
import { Scrollbar } from '@app/components';
import { getClientDetails, getClientDetailsById } from '../slice';

const ClientDetailsPage = () => {
  const tableProps = useTable();
  const editDialog = useDialog();
  const dispatch = useDispatch();
  const { state } = useLocation();
  const clientId = state.id;

  useEffect(() => {
    if (clientId) {
      dispatch(getClientDetails(clientId));
      dispatch(getClientDetailsById(clientId));
    }
  }, [clientId, dispatch]);
  const { data, loading } = useRequestState({
    stateSelector: selectClientDetailsState,
    errorShown: true,
  });

  const { data: clientDetails } = useRequestState({
    stateSelector: selectClientDetailsByIdState,
    errorShown: true,
  });
  const goBack = () => {
    history.back();
  };
  return (
    <>
      <Box sx={{ mr: 3 }}>
        <Header
          goBack={goBack}
          title={Strings.page_title.details}
          helperText={''}
          actionButtonTitle={Strings.button.editClient}
          onClickActionButton={editDialog.show}
        />
      </Box>
      <Scrollbar>
        <ClientProfile clientData={clientDetails} />
        <ClientDetailsList tableProps={tableProps} loading={loading} data={data} />
      </Scrollbar>
      {editDialog.visible && (
        <AddClient row={clientDetails} open={editDialog.visible} onClose={editDialog.hide} />
      )}
    </>
  );
};
export { ClientDetailsPage };
